// extracted by mini-css-extract-plugin
module.exports = {"cookieTable":"CookieTable-module--cookie-table--3uZ5o","divider":"CookieTable-module--divider--MrAD3"};